import { useEffect, useState, FC, useRef } from "react";
import { Form } from 'antd'
import { YhFormBox } from "@/components/YhFormBox";
import { IYhFormBox, IYhFormItemsBox, FormItemTypeEnum, IYhFormRef } from "@/components/YhFormBox/Types";
import useNavModel, { RouterParamType } from "@/model/navModel";
import { useGlobalModel } from "@/model/globalModel";
import { useMaintenanceDetailsModel } from "../MaintenanceModel";

const OrderReturnStatus = new Map([
    ["pending_review", "待审核"],
    ["billed", "已开单"],
    ["in_stock", "已入库"],
    ["settled", "已结算"],
]);

export const FormBox: FC<RouterParamType> = () => {
    const formRef = useRef<IYhFormRef>();
    const {
        detailLookForm,
        getDetailOne,
    } = useMaintenanceDetailsModel();

    const {
        ciGetTreeNodeValue
    } = useGlobalModel(() => []);

    const { getSelectedNavState } = useNavModel();
    const [detailsInfo] = useState<RouterParamType>(getSelectedNavState() as RouterParamType);
    const { id } = detailsInfo

    useEffect(() => {
        getDetailOne(id)
    }, [id])

    const title = <>
        <div style={{ marginBottom: 10, marginLeft: 10, color: '#333' }}>
            <span style={{ fontSize: 16, marginRight: 20 }}>{`工单编号:${detailLookForm.orderCode}`}</span>
            <span style={{ fontSize: 16, marginRight: 20 }}>{`状态:${ciGetTreeNodeValue(detailLookForm.orderStatus)}`}</span>
            <span style={{ fontSize: 16, marginRight: 20 }}>{`工单来源:${ciGetTreeNodeValue(detailLookForm.orderSource)}`}</span>
        </div>
    </>
    const baseFormItem: IYhFormItemsBox = {
        title: title,
        style: { padding: "18px 0 0 0", marginBottom: 10 },
        contentClass: "pr-77",
        items: [
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: '基础信息',
                fieldName: 'file',
                colClassName: 'ant-col-h-auto',
                span: 24,
                formItem: (
                    <Form.Item>
                        <span style={{ fontSize: 20, fontWeight: 'bold', paddingLeft: 25 }}>基础信息</span>
                    </Form.Item>
                ),
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '客户名称',
                fieldName: "customerName",
                labelCol: { span: 6 },
                span: 6
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '车辆牌照',
                fieldName: "customerVehicleCode",
                labelCol: { span: 6 },
                span: 6
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '报修用户',
                fieldName: "repairContactName",
                labelCol: { span: 6 },
                span: 6
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '服务方式',
                fieldName: "serviceMethod",
                labelCol: { span: 6 },
                span: 6
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '故障类型',
                fieldName: "serviceType",
                labelCol: { span: 6 },
                span: 6
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '工单类型',
                fieldName: "orderType",
                labelCol: { span: 6 },
                span: 6
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '行驶里程',
                fieldName: "customerVehicleMileage",
                labelCol: { span: 6 },
                span: 6
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '救援里程',
                fieldName: "mileage",
                labelCol: { span: 6 },
                span: 6
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '报修地址',
                fieldName: "repairAddress",
                labelCol: { span: 3 },
                span: 12
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '故障描述',
                fieldName: "faultDesc",
                labelCol: { span: 3 },
                span: 12
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '备注',
                fieldName: "remark",
                labelCol: { span: 3 },
                span: 12
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '处理结果',
                fieldName: "processResult",
                labelCol: { span: 6 },
                span: 6
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: '所属实体',
                fieldName: "ciBusinessEntityName",
                labelCol: { span: 6 },
                span: 6
            }
        ]
    };
    const poFromConfig: IYhFormBox = {
        formRef,
        //disabled: true,
        labelCol: { span: 6 },
        labelAlign: "right",
        formValues: detailLookForm,
        boxs: [baseFormItem]
    }


    return (
        <YhFormBox {...poFromConfig} />
    )
}